module.exports = __webpack_public_path__ + "static/media/session-expired-desktop.13f4b963.svg";